import {useCallback} from 'react';

import {useCommonEventHook} from 'src/hooks/use-common-event-hook';
import {removeUser} from 'src/openapi/admin/apis/UserLifecycleApi';
import {useAppDispatch} from 'src/store/hooks';

import type {ActionOptions} from 'src/components/save-with-reason/action-with-reason-button';

type Props = {
    userId: number,
    onSuccess: () => void,
};

export const useDeleteUser = ({userId, onSuccess}: Props) => {
    const apiDispatch = useAppDispatch();

    const eventAction = useCallback((options?: ActionOptions) => apiDispatch(
        removeUser({userId, reason: options?.reason}),
    ), [userId, apiDispatch]);

    return useCommonEventHook({eventAction, onSuccess});
};
